import SubPub from '../utilities/subpub';


/**
 * The Base Component for all the other components
 */

export default class {

  constructor (element) {

    let prototype = this.__proto__
    let constructor = this.constructor

    // Register Component class to App if not yet registered
    if ( !(constructor.name in App.components) )  {
      App.registerComponentClass(constructor);
    }

    // Should only accept HTMLElement instances
    if ( !(element instanceof HTMLElement) ) throw `Unable to bind a non-HTMLElement object to ${constructor.name}`;

    // Should not allow rebind
    if ( element[constructor.name] ) throw `Element is already bound to ${constructor.name}`;

    // Add collection
    prototype.collection = prototype.collection || [];

    // Add eventHandler
    let eventHandler;
    this.__defineGetter__('eventHandler', function () {
      if ( !eventHandler ) { eventHandler = new SubPub; }
      return eventHandler;
    });


    // Attach common properties
    this.element = element;
    this.$element = $(element);

    // Attach component data to DOM
    this.element[prototype.name] = this;

    // Add to static collection
    this.addToCollection();

    // Emit event
    this.$element.trigger('componentbound');

  }

  // Returns an object whose properties will be attached to the component class
  decorator () {
    return {
      // selector : '.js-test-component',
      // name : 'TestComponent'
    }
  }

  addToCollection () {
    this.collection.push(this);
  }


  static decorate () {

    if ( this.decorated || typeof this.decorator !== 'function' ) return;

    let prototype = this.prototype;
    let decoration = this.decorator();
    for ( let prop in decoration ) {
      prototype[prop] = decoration[prop];
    }

    this.decorated = true;

  }


  static get decorator () {
    return this.prototype.decorator;
  }

  static get collection () {
    return this.prototype.collection;
  }

  static get selector () {
    this.decorate();
    if ( this.decorated && this.prototype.selector ) {
      return this.prototype.selector;
    }
  }

  static get (index) {
    let _proto = this.prototype;

    if ( typeof index !== 'number' ) return;
    if ( !_proto.collection || index >= _proto.collection.length ) return;

    return _proto.collection[index];
  }

  static bindElement ( element ) {
    let constructor = this;
    return new constructor(element);
  }


  static onElementBound ( element, callback = () => {} ) {

    if ( !(element instanceof HTMLElement) ) return console.warn('Unable to listen to a non-HTMLElement.');

    let constructor = this;
    let prototype = this.prototype;

    if ( element[prototype.name] ) return callback.call(element[prototype.name]);

    $(element).on('componentbound', function () {
      callback.call( element[prototype.name] );
    });

  }





}
